import { string } from 'prop-types';

export enum PageId {
  start = 'start',
  intro = 'intro',
  sleepers = 'sleepers',
  mattressSize = 'mattressSize',
  name = 'name',
  bodyMeasurements = 'bodyMeasurements',
  weight = 'weight',
  height = 'height',
  waist = 'waist',
  sleepPosition = 'sleepPosition',
  sleepGoal = 'sleepGoal',
  sleepProfile = 'sleepProfile',
  calculatingResults = 'calculatingResults',
  results = 'results',
  sharedSleepGoal = 'sharedSleepGoal',
}

export enum Labels {
  noSleepers = 'Number of sleepers',
  mattressSize = 'Mattress Size',
  name = 'Name',
  height = 'Height',
  weight = 'Weight',
  waist = 'Waist',
  sleepGoal = 'Sleep Goal',
  sleepPosition = 'Sleep Position',
}
